// Logos
import logo from '../assets/logo.webp';
import logo3d from '../assets/logo-3d.webp';
import nairdccmpct from '../assets/N.webp';
import instagramIcon from '../assets/instagram-svgrepo-com.svg';
import linkedInIcon from '../assets/linkedin-svgrepo-com.svg';
import xIcon from '../assets/X_logo_2023.svg';
import nairdc3d from '../assets/Nairdc3d.webp';
import homesvg from '../assets/Homepage.svg';

// Misc
import arrowLeft from '../assets/arrow-left.webp';
import arrowRight from '../assets/arrow-right.webp';
import eleone from '../assets/Element-2.webp';
import eletwo from '../assets/Element-1.webp';
import elethree from '../assets/Circle png.webp';
import elefour from '../assets/BG-Element-2.webp';
import elefive from '../assets/BG-Element-3.webp';
import elesix from '../assets/BG-Element-6.webp';
import one from '../assets/one-icon.webp';
import two from '../assets/two-icon.webp';
import three from '../assets/three-icon.webp';
import four from '../assets/four-icon.webp';
import five from '../assets/five-icon.webp';
import bgBlur from "../assets/blur-bg.webp";
import circleIcon from '../assets/circle-icon.webp';
import aisvg from '../assets/aisvg.svg';
import comingSoon from '../assets/coming-soon.webp';
import landing1 from '../assets/Main Banner.mp4';
import landing2 from '../assets/Chatbot Banner2.mp4';
import landing3 from '../assets/Dashboards Banner.mp4';
import landing1AR from '../assets/Main Banner (AR).mp4';
import landing2AR from '../assets/Chatbot Banner2 (AR).mp4';
import landing3AR from '../assets/Dashboards Banner (AR).mp4';
import pedestal from '../assets/pedestal.webp';

import values from '../assets/values-icon.webp';
import vision from '../assets/vision-icon.webp';
import mission from '../assets/Mission 2.webp';
import location from '../assets/location-icon.webp';
import phone from '../assets/phone-icon.webp';
import mail from '../assets/mail-icon.webp';

import awardWinning from '../assets/award-winning-icon.webp';
import bahrainIcon from '../assets/bahrain-icon.webp';

//Partners
import alba from '../assets/01Alba.webp';
import asry from '../assets/04ASRY.webp';
import BAS from '../assets/BAS.webp';
import BapcoG from '../assets/Bapco Gas.webp';
import BapcoR from '../assets/Bapco Refining.webp';
import benefit from '../assets/06Benefit.webp';
import CBB from '../assets/CBB.webp';
import CSB from '../assets/CSB.webp';
import edb from '../assets/08EDB.webp';
import GDTraffic from '../assets/Traffic.webp';
import GovHospitals from '../assets/Gov Hospitals.webp';
import IGA from '../assets/IGA.webp';
import MUN from '../assets/MUN.webp';
import MOIC from '../assets/MOIC.webp';
import MOI from '../assets/MOI.webp';
import MOW from '../assets/MOW.webp';
import NAO from '../assets/NAO.webp';
import Shura from '../assets/Shura Council.webp';
import SLRB from '../assets/SLRB.webp';
import Tamkeen from '../assets/Tamkeen.webp';
import YBAKanoo from '../assets/YBA Kanoo.webp';
import zain from '../assets/16Zain.webp';

//Services

//Skills
import skillscss from '../assets/css.svg';
import skillsdjango from '../assets/django.svg';
import skillsjquery from '../assets/jquery.svg';
import skillsflutter from '../assets/flutter.svg';
import skillshtml from '../assets/html.svg';
import skillsjs from '../assets/js.svg';
import skillsjupyter from '../assets/jupyter.svg';
import skillskeras from '../assets/keras.svg';
import skillslangchain from '../assets/langchain.webp';
import skillsmatplotlib from '../assets/matplotlib.svg';
import skillsnumpy from '../assets/numpy.svg';
import skillsopencv from '../assets/opencv.svg';
import skillssql from '../assets/sql.svg';
import skillspandas from '../assets/pandas.svg';
import skillsplotly from '../assets/skills plotly.webp';
import skillspowerbi from '../assets/power bi.svg';
import skillspython from '../assets/python.svg';
import skillspytorch from '../assets/pytorch.svg';
import skillsreact from '../assets/react.svg';
import skillsscikit from '../assets/scikit.svg';
import skillstensor from '../assets/tensorflow.svg';
import skillsvue from '../assets/vue.svg';
import skillsseaborn from '../assets/seaborn.svg';

// 3d imgs
import dataAnalytics from '../assets/blockchain-icon.webp';
import chatBot from '../assets/chatbot-icon.webp';
import compCost from '../assets/competitive-costs-icon.webp';
import computerVision from '../assets/computer-vision-icon.webp';
import customization from '../assets/customization-icon.webp';
import blockchain from '../assets/data-analytics-icon.webp';
import iot from '../assets/iot-icon.webp';
import ocr from '../assets/ocr-icon.webp';
import predictionForecasting from '../assets/prediction-forecasting-icon.webp';
import dashboard from '../assets/real-time-dashboard-icon.webp';
import recommendationSystem from '../assets/recommendation-system-icon.webp';
import rfid from '../assets/rfid-icon.webp';
import roboticSolutions from '../assets/robotic-solutions-icon.webp';
import rpa from '../assets/rpa-icon.webp';
import support from '../assets/support-icon.webp';

//Videos
import chatbotVid from "../assets/Chatbot.mp4";
import chatbotVidL from "../assets/Chatbot Animated.mp4";
import blockchainVid from '../assets/LLM Icon.mp4';
import computerVisionVid from '../assets/Computer-Vision.mp4'
import dashboardVid from '../assets/Dashboard.mp4';
import dataAnalyticsVid from '../assets/ML Icon.mp4'
import iotVid from '../assets/ERP Icon.mp4';
import ocrVid from '../assets/GenAI Icon.mp4'
import predictionandforecastingVid from '../assets/Prediction-and-Forecasting.mp4';
import recosystemVid from '../assets/Recommendation-System.mp4';
import rfidVid from '../assets/RFID.mp4';
import robosysVid from '../assets/Robotic-Solutions.mp4';
import rpaVid from '../assets/RPA.mp4';

//Media
import pVR from '../assets/vrimage.webp';
import uxui from '../assets/uxui.webp';
import locpin from '../assets/locationpin.webp';
import custexp from '../assets/customerexp.webp';
import chatbottool from '../assets/chatbottool.webp';
import aibot from '../assets/3dbot.avif';


export default {

    logo, nairdccmpct, logo3d, homesvg, nairdc3d,
    
    arrowLeft, arrowRight, one, two, three, five, four, bgBlur, circleIcon, comingSoon, aisvg, landing1, landing2, landing3, landing1AR, landing2AR, landing3AR, pedestal,
    
    awardWinning, bahrainIcon, support, location, mail, mission, values, vision,
    
    blockchain, chatBot, compCost, computerVision, customization, dataAnalytics, iot, ocr, phone, predictionForecasting, dashboard, recommendationSystem, rfid, roboticSolutions, rpa,
    
    chatbotVid, blockchainVid, computerVisionVid, dashboardVid, dataAnalyticsVid, iotVid, ocrVid, predictionandforecastingVid, recosystemVid, rfidVid, robosysVid, rpaVid,
    
    alba, asry, BAS, BapcoG, BapcoR, benefit, CBB, CSB, edb, GDTraffic, GovHospitals, IGA, MUN, MOIC, MOI, MOW, NAO, Shura, SLRB, Tamkeen, YBAKanoo, zain,
    
    skillscss, skillsdjango, skillsjquery, skillsflutter, skillshtml, skillsjs, skillsjupyter, skillskeras, skillslangchain, skillsmatplotlib, skillsnumpy, skillsopencv, skillssql, skillspandas, skillsplotly, skillspowerbi, skillspython, skillspytorch, skillsreact, skillsscikit, skillstensor, skillsvue, skillsseaborn,
    
    chatbotVidL, eleone, eletwo, elethree, elefour, elefive, elesix, instagramIcon, linkedInIcon, xIcon,

    pVR, uxui, locpin, custexp, chatbottool, aibot, 
};